export default __webpack_public_path__ + "static/media/aydinlatmaMetni.ce3df8cf.pdf";